__webpack_require__.p = "https://res.mingweigz.com/wms/app/";